(function() {
	/**
	 * @exports DKA.controllers.batteryLifeCalculator
	 * @requires HBS
	 */
	

	// This file is a spreadsheet conversion to JavaScript
	// Forumals are based off dormakaba's "Battery Life Calculator"
	// Spreadsheet is located in assets/references/Blue_battery_runtime.xlsx
	
	let module = {};

	var cycleDay = ["0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25"];
	var yearBatt = [ "8.6446658","6.782145","5.579931","4.7397545","4.1194797","3.6427642","3.2649382","2.9581229","2.7040187","2.4901165","2.3075751","2.1499687","2.0125148","1.8915804","1.7843564","1.6886362","1.602663","1.52502","1.454552","1.390309","1.3315005","1.277465","1.227645","1.181564","1.138818","1.099057"];

	module.init = () => {
		module.setupInputChangeHandlers();
		module.enableDisableFormSubmit();
		module.inputChangeValidator();
		module.calculateActivations();
		module.calculateRuntime();
	};

	module.calculateActivations = function() {

		//Reference cycle/day column
		var activationsField = jQuery('input#input_6_1').val() > 25 ? "25" : jQuery('input#input_6_1').val();

		var closestActivationValue = cycleDay.reduce((prev, curr) => Math.abs(curr - activationsField) < Math.abs(prev - activationsField) ? curr : prev);
	
		var index = cycleDay.indexOf(activationsField);

		var yearBattValue = yearBatt[index];

		var calculateDays = yearBattValue * 365;
		calculateDays = calculateDays.toFixed(0);

		var activationsToMonths = (Math.ceil(calculateDays / 30) / 12).toFixed(1);

		var activationsYears = activationsToMonths.toString().split(".")[0];
		var activationsMonths = activationsToMonths.toString().split(".")[1];

		jQuery('input#input_6_10').val(activationsYears);
		jQuery('input#input_6_15').val(activationsMonths);
	};

	module.calculateRuntime = function() {

		//Reference Year Batt column

		var batterylifeField = jQuery('input#input_6_2').val();

		var closestBattLifeValue = yearBatt.reduce((prev, curr) => Math.abs(curr - batterylifeField) < Math.abs(prev - batterylifeField) ? curr : prev);
		
		var cycleDayValue = yearBatt.indexOf(closestBattLifeValue);

		jQuery('input#input_6_11').val(cycleDayValue);
		jQuery('input#input_6_14').val((cycleDayValue * 365).toLocaleString());


	};

	module.setupInputChangeHandlers = function() {


		//Activations per Day
		jQuery('input#input_6_1').on('keyup', function(e){

			if (jQuery.isNumeric(jQuery(this).val()) === false) {
		        //chop off the last char entered
		        this.value = this.value.slice(0,-1);
		   	}

			if ( this.value > 25 ) {
				jQuery('.switchcore-notice').fadeIn();
			} else {
				jQuery('.switchcore-notice').fadeOut();
				jQuery('.switchcore-notice').removeClass('switchcore-notice--display');
			}

			module.calculateActivations();
			module.restrictInputsToNumberedRange(this, '', 25);
		});
		
		//Battery Life
		jQuery('input#input_6_2').on('keyup', function(e){
			if (jQuery.isNumeric(jQuery(this).val()) === false) {
		        //chop off the last char entered
		        this.value = this.value.slice(0,-1);
		   	}

		   	module.calculateRuntime();
		   	module.restrictInputsToNumberedRange(this, '', 8);
		});

	};

	module.validateSubmitButton = function() {
		var submitButton = jQuery('#gform_submit_button_6');
		submitButton.on('click', function(e){
			if (submitButton.hasClass('disabled') ) {
				e.preventDefault();
			}
		});
	};

	module.validateForm = function() {
		var isValid = true;
		jQuery('.gfield.validate:visible input').each(function() {
			if ( jQuery(this).val() === '' )
			isValid = false;
		});
		
		return isValid;
	};

	module.inputChangeValidator = function() {
		var submitButton = jQuery('#gform_submit_button_6');
		jQuery('.gfield.validate input').on('keyup', function(){
			if ( module.validateForm() == true ) {
				submitButton.removeClass('disabled');
			} else {
				submitButton.addClass('disabled');
			}
		});
	};

	module.enableDisableFormSubmit = function() {
		var submitButton = jQuery('#gform_submit_button_6');
		if ( module.validateForm() == true ) {
			submitButton.removeClass('disabled');
		} else {
			submitButton.addClass('disabled');
		}
	};

	module.restrictInputsToNumberedRange = function(input, min, max) {
		input.value = input.value.replace(/[^0-9\.]/g,'');

		if (input.value == 0 && input.value.length == 1) {
			input.value = min;
		} 

		if ( input.value > max ) {
			input.value = max;
		}
	};

	HBS.namespace('DKA.controllers.batteryLifeCalculator', module);
}());